import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from 'src/app/_core/_services/content.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { Location } from "@angular/common";
import { GlobalService } from 'src/app/_core/global.service';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  public pageSearchType: boolean
  public pageTitle: string
  public catContents: any
  public showSeeMore: boolean = true
  public loadingContents: boolean = false
  private categoryId: number
  private contPageCount: number
  private contPageSize: number

  constructor(
    private neo: ContentService,
    private route: ActivatedRoute,
    private beh: BehaviorService,
    public _location: Location,
    public global: GlobalService
  ) {
    this.route.params.subscribe(params => {
      this.catContents = null
      this.contPageCount = 1
      this.contPageSize = window.innerWidth >= 768 ? 36 : 18

      if (params.categoryId) {
        this.pageSearchType = false
        this.categoryId = +params.categoryId
        this.getCategoryContent()
      } else if (params.searchKey) {
        this.pageSearchType = true
        this.getSearchResult(params.searchKey)
      }
    })
  }

  ngOnInit() { }

  public getMoreContent() {
    this.loadingContents = true
    this.neo.loadCategoryContent(this.categoryId, this.contPageSize, this.contPageCount).subscribe(contents => {
      if (contents?.result && this.catContents == null) { this.catContents = [] }
      for (let game of contents.result) { this.catContents.push(game) }
      this.contPageCount++
      this.showSeeMore = contents.totalNumberOfElements > this.catContents.length ? true : false
      this.loadingContents = false
    })
  }

  private getCategoryContent() {
    this.beh._categories.subscribe(allCat => {
      for (let cat of allCat) {
        if (cat.catId == this.categoryId) { this.pageTitle = cat.catName }
      }
    })
    this.getMoreContent()
  }

  private getSearchResult(keyword) {
    this.catContents = null
    this.pageTitle = keyword
    this.neo.searchByKeyword(keyword).subscribe(resp => {
      if (resp?.result) {
        this.catContents = []
        let keys = []
        for (let game of resp.result) {
          if (keys.indexOf(game['id']) === -1) {
            keys.push(game['id'])
            this.catContents.push(game)
          }
        }
      } else { this.catContents = [] }
    }, () => { this.catContents = [] })
  }

}
